var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#525D70","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M4 8.001h6a2.667 2.667 0 0 1 0 5.334H4.667A.667.667 0 0 1 4 12.668V3.335a.667.667 0 0 1 .667-.667h4.666a2.667 2.667 0 1 1 0 5.333"}})])
}
var staticRenderFns = []

export default { render: render }